import React from 'react';

export default function Hero({ projectName }) {
  return (
    <section className="hero">
      <h1>Progetto Residenziale "{projectName}"</h1>
      <p>Monitora lo stato delle proprietà, vendite e costi del progetto in tempo reale</p>
    </section>
  );
}
